<div id="main-my-dashboard">
  <!-- <div class="iconBar  sticky-body">
        <img class="icon mr-3" src={{props.srcPath}}>
        {{props.pageName}} -->
  <div class=" iconBar sticky-body row">
    <div class="col-6" style="padding-top: 5px;">
      <img class="icon mr-3" height="25px" src={{props.srcPath}} alt="">
      <span class="mat-title">{{props.pageName}}</span>
    </div>
    <div class="pt-2 groupLabel"><span>Select group: </span></div>
    <div class="col-3 org-dropdown">
      <mat-select class="mat-body-1 p-2" (selectionChange)="groupChange($event)" [(value)]="loggedInUserGroup">
        <mat-optgroup class="mat-body-1" color="primary" *ngFor="let group of orgs" [label]="group.organizationName"
          [disabled]="group.disabled">
          <mat-option class="mat-body-1" *ngFor="let fields of group.groups" [value]="fields.groupId">
            {{fields.groupName}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </div>
  </div>

  <div class="row my-5 mx-2 px-0 pt-5 col-12 d-flex justify-content-center">
    <div class="row col-10 d-flex space-between">
    <!-- <div class="col-1 pt-5 mt-3 justify-content-end mat-title"></div> -->
    <div class=" pt-5 mt-3  mat-title"><strong class="">
        {{props.lblName}}</strong>
    </div>
  

    <!-- <div class="col-md-auto">
      Variable width content
    </div> -->
    <div class="mr-4">
      <button mat-stroked-button class="button-drawer mt-5 filledBtnStyle" *ngIf="props.dashboardType != 4 && loggedInUserTypeId != 3"
        (click)="create()">{{props.btnCreateText}}</button>
    </div>
  </div>
</div>

  <div *ngIf="dataNull">
    <p class="msg row m-5 createlbl mat-title">{{props.noDataMsg}}</p>
  </div>
  <div class="row-12 w-100 d-flex justify-content-center">
    <div class="scrollable col-10 ">
      <div class="w-100 col-12">        
        <mat-accordion [togglePosition]="'before'">
          <mat-expansion-panel class="matPanel mat-elevation-z0" *ngFor="let d of props.data">            
            <mat-expansion-panel-header class="expansionArrow">
              <mat-panel-title class="matTitle mat-subheading-2 padding-top-29">
                {{d.name}}
              </mat-panel-title>
              <mat-panel-description class="matDesc mat-subheading-2 padding-top-29">
                Created on {{d.createdDate | date: 'MM/dd/yyyy'}}
                <div class="dropdown">
                  <div class="dropdown-content">
                    <em (click)="$event.stopPropagation()" *ngIf="loggedInUserTypeId != 3" [matMenuTriggerFor]="menu" aria-expanded="false">
                      <fa-icon [icon]="faEllipsisV"></fa-icon>
                  </em>
                    <mat-menu #menu="matMenu">                                       
                      <button
                        *ngIf="props.dashboardType == 1 && (d.status == 'S' || d.status == 'Save') && d.isREResponse == false 
                        && ((d.isMultipleResponseAllowed && d.isCPResponse) || (!d.isMultipleResponseAllowed && !d.isCPResponse) || 
                        ((d.status == 'S' || d.status == 'Save') && d.resultsCount == 0) )  
                        && (d.isOverdueAccessAllowed || (!d.isOverdueAccessAllowed && !d.isOverdue))"
                        mat-menu-item (click)="takeSurvey(d.id)">
                        <span>Take Assessment / Survey</span>
                      </button>
                      <button
                        *ngIf="props.dashboardType == 1 && (d.status == 'S' || d.status == 'Save') && d.isREResponse == true && d.isCPResponse == false && (d.isOverdueAccessAllowed||(!d.isOverdueAccessAllowed&&!d.isOverdue))"
                        mat-menu-item (click)="resumeSurvey(d.id)">
                        <span>Resume Assessment / Survey</span>
                      </button>
                      <button
                        *ngIf="props.dashboardType == 1 && (d.status == 'S' || d.status == 'Save') &&(d.inprogressCount<=0 && d.resultsCount ==1 &&d.isCPResponse)"
                        mat-menu-item (click)="viewSurvey(d.id)">
                        <span>View response</span>
                      </button>
                      <button *ngIf="props.dashboardType == 1 && (d.status == 'S' || d.status == 'Save')&& (!(d.inprogressCount<=0 && d.resultsCount ==1 && d.isCPResponse))&& (d.resultsCount>0 || d.inprogressCount>0)" mat-menu-item (click)="viewCompletedSurvey(d.id)">
                        <span>View response(s)</span>
                      </button>
                      <button *ngIf="props.dashboardType != 4 && loggedInUserTypeId != 3" mat-menu-item (click)="edit(d.id)">
                        <span>Edit</span>
                      </button>
                      <button *ngIf="props.dashboardType != 4 && loggedInUserTypeId != 3" mat-menu-item (click)="delete(d.id,d.groupId)">
                        <span>Delete</span>
                      </button>
                      <div
                        *ngIf="(d.status == 'S' || d.status == 'Save') && d.createdByUserId.toUpperCase()==loggedInuserId && props.dashboardType != 4 && loggedInUserTypeId != 3">
                        <button mat-menu-item (click)="share(d.id)">
                          <span>Share</span>
                        </button>
                      </div>
                      <button *ngIf="props.dashboardType == 4" mat-menu-item (click)="createNewTemplate(d.id)">
                        <span>Create as new</span>
                      </button>
                      <button *ngIf="props.dashboardType == 1 && (d.status == 'S' || d.status == 'Save')"  mat-menu-item (click)="result(d.id)">
                        <span>Result</span>
                      </button>
                      <button *ngIf="props.dashboardType == 4" mat-menu-item (click)="removeTemplate(d.id,d.groupId)">
                        <span>Remove template</span>
                      </button>
                      <button *ngIf="props.dashboardType == 1 && loggedInUserTypeId != 3" mat-menu-item (click)="loadSettings(d.id)">
                        <span>Settings</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <p><span class="mat-body-2">Description</span><span class="mat-body-1"> {{d.description}}</span></p>
            <p><span class="mat-body-2">Created by</span><span class="mat-body-1"> : {{d.FirstName}} {{d.LastName}}
                ({{d.createdUserGroupName}})
              </span></p>
            <p *ngIf="d.status == 'Save' || d.status == 'S'"><span class="mat-body-2">Shared With</span>:
              <span *ngIf="d.sharedWithGroupList != null && d.sharedWithGroupList.length > 0">
                <span class="mat-body-1" *ngFor="let grpName of d.sharedWithGroupList let isLast=last"> 
                  {{grpName}}{{isLast ? '' : ', '}}
                </span>
              </span>    {{d.sharedWithGroupList}}          
              <span *ngIf="d.sharedWithGroupList == null || d.sharedWithGroupList.length == 0">
                None
              </span>
            </p>
            <p><span class="mat-body-2">Status</span><span class="mat-body-1"> : {{(d.status == 'S' || d.status == 'Save') ? 'Published' : 'Draft'}}</span></p>

          </mat-expansion-panel>
        </mat-accordion>

      </div>
    </div>
  </div>
</div>